import {
    Box,
    Typography,
    Link as MuiLink,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import { GitHub, Article, Language, ExpandMore } from '@mui/icons-material';

export const Basics = () => {
    const topics = [
        {
            title: "01 Mean",
            videoId: "TAHr-dLsDy8",
            mediumLink: "https://kmeeraj.medium.com/01-mean-9f2e2eb1d19a",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://www.youtube.com/watch?v=TGvSkbYb8oA&list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://www.youtube.com/watch?v=9CMgNDcmfgk&list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        },
        {
            title: "02 - Covariance Matrix",
            videoId: "120k1UVuZHI",
            mediumLink: "https://kmeeraj.medium.com/02-covariance-matrix-d088a5796ff2",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/BweHu3TeLdM?list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://youtu.be/h4sMW9sgwsw?list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        },
        {
            title: "03 Eigen Values and Vectors",
            videoId: "flZI65Ylttg",
            mediumLink: "https://kmeeraj.medium.com/03-eigen-values-and-eigen-vectors-d5255a5d5483",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/ckI-o-XT1bk?list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://youtu.be/N4TbUh5uSzQ?list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        },
        {
            title: "04 Singular Value Decomposition",
            videoId: "TCExTpJnpNY",
            mediumLink: "https://kmeeraj.medium.com/03-eigen-values-and-eigen-vectors-d5255a5d5483",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/qJ8Vqe4PX70?list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://youtu.be/ckQUSHv6HVs?list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        },
        {
            title: "07 - Loss Function",
            videoId: "120k1UVuZHI",
            mediumLink: "https://kmeeraj.medium.com/02-covariance-matrix-d088a5796ff2",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/e-1FbCtYKQY?list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://youtu.be/dZ7uMwy4Kyc?list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        },
        {
            title: "08 - Gradient Descent",
            videoId: "phTWgFd1ZvU",
            mediumLink: "https://kmeeraj.medium.com/02-covariance-matrix-d088a5796ff2",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/V9U2QBgBJBo?list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://youtu.be/aI24UiKpQ1g?list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        },
        {
            title: "12 - Simple Naive Bayes",
            videoId: "t79W78TiBJ4",
            mediumLink: "https://kmeeraj.medium.com/simple-naive-bayes-c50415438bed",
            githubLink: "https://github.com/kmeeraj/machinelearning/tree/develop",
            hindiLink: "https://youtu.be/BweHu3TeLdM?list=PL01e4bnNRw-TyOmg_LHziwfa0HVfqOF9J",
            teluguLink: "https://youtu.be/h4sMW9sgwsw?list=PL01e4bnNRw-RFxA2sst7KLZL1kN_36n-J"
        }
    ];

    return(
        <Box>
            <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
                Basics of Machine Learning
            </Typography>
            
            {topics.map((topic, index) => (
                <Accordion key={index} sx={{ mb: 2 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography variant="h6">{topic.title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <iframe 
                                width="100%" 
                                height="300"
                                src={`https://www.youtube.com/embed/${topic.videoId}?list=PL01e4bnNRw-S71tN3OJGEMbvb9blR733G`}
                                title="YouTube video player" 
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                            <Chip
                                icon={<Article />}
                                label="Medium Article"
                                component={MuiLink}
                                href={topic.mediumLink}
                                target="_blank"
                                clickable
                                color="primary"
                            />
                            <Chip
                                icon={<GitHub />}
                                label="GitHub"
                                component={MuiLink}
                                href={topic.githubLink}
                                target="_blank"
                                clickable
                                color="secondary"
                            />
                            <Chip
                                icon={<Language />}
                                label="Hindi"
                                component={MuiLink}
                                href={topic.hindiLink}
                                target="_blank"
                                clickable
                                color="success"
                            />
                            <Chip
                                icon={<Language />}
                                label="Telugu"
                                component={MuiLink}
                                href={topic.teluguLink}
                                target="_blank"
                                clickable
                                color="warning"
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    )
}